import { Link as RouterLink, type LinkProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localizePath, type Locale } from '../../lib/locale';

// Internal links are written as Chinese paths ("/pricing#contact"); on English pages they are
// prefixed with /en so the visitor stays in their language. External and mailto links pass through.
export function useLocalePath() {
  const { i18n } = useTranslation();
  const locale: Locale = i18n.language.startsWith('en') ? 'en' : 'zh';
  return (path: string) => (path.startsWith('/') ? localizePath(path, locale) : path);
}

export function Link({ to, ...rest }: LinkProps) {
  const lp = useLocalePath();
  return <RouterLink to={typeof to === 'string' ? lp(to) : to} {...rest} />;
}
